(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.stickyHeader = {

    attach: function attach(context) {
      const scrollCheck = () => {
        const scrollTopWindow = $(window).scrollTop();
        const elementOffset = $('.layout-container').offset().top;

        if (scrollTopWindow > elementOffset) {
          $('header').addClass('sticky');
        } else {
          $('header').removeClass('sticky');
        }
      };

      $(window).scroll(scrollCheck);
      $(window).ready(scrollCheck);

      const mobMenu = document.querySelector('[data-region="mobile_header"]');
      const btnAbout = document.getElementById("back-about-us");

      // Desktop menu: the flyout opens on hover/focus of its own item only,
      // and the "Menu" link itself navigates on click (matches live
      // themeltdown.com).
      const $desktopItem = $('.layout__region--header .block-menu-block-meltdown-mainnavigation .main-menu-item')
        .filter(function () {
          return $(this).children('.dropdown-item--children').length > 0;
        });
      const openDesktop = function () {
        $(this).addClass('is-open')
          .children('.dropdown-item').attr('aria-expanded', 'true');
      };
      const closeDesktop = function () {
        $(this).removeClass('is-open')
          .children('.dropdown-item').attr('aria-expanded', 'false');
      };
      $desktopItem.hover(openDesktop, closeDesktop);
      $desktopItem.on('focusin', openDesktop).on('focusout', function (e) {
        if (!this.contains(e.relatedTarget)) {
          closeDesktop.call(this);
        }
      });
      // Mobile Menu: submenu items render expanded in the drawer, so links
      // navigate; only the (hidden) Back control toggles.
      $('.layout__region--mobile-header .back').click(function (e) {
        // Aria for accessibility
        if($('.layout__region--mobile-header .dropdown-item').attr('aria-expanded') === 'true') {
          $('.layout__region--mobile-header .dropdown-item').attr('aria-expanded', 'false');
        } else {
          $('.layout__region--mobile-header .dropdown-item').attr('aria-expanded', 'true');
        }
        $('.layout__region--mobile-header').toggleClass('dropdown-open');
        e.preventDefault();
        return false;
      });
      // Accessibility
      $('#burger-menu, .header__sign-in').click(function (e) {
        mobMenu.focus();
        e.preventDefault();
        return false;
      });
      // Accessibility
      $('#burger-close-button').click(function (e) {
        e.preventDefault();
        return false;
      });
      // Accessibility
      $(btnAbout).click(function (e) {
        mobMenu.focus();
        e.preventDefault();
        return false;
      });

      if (btnAbout) {
        const observer = new IntersectionObserver((entries) => {
          if(entries[0].isIntersecting){
            btnAbout.focus();
          } else {}
        });
        observer.observe(btnAbout);
      }
    }
  };
})(Drupal, jQuery);
